module.exports = __webpack_public_path__ + "static/media/hardware_store.4ba98a82.jpg";